import { NgModule } from "@angular/core"
import { RouterModule, Routes } from "@angular/router"
import { StudentHomepageComponent } from "./student-homepage/student-homepage.component"
import { StudentAssignmentComponent } from "./student-assignment/student-assignment.component"
import { StudentClassesComponent } from "./student-classes/student-classes.component"
import { StudentAssignmentsComponent } from "./student-assignments/student-assignments.component"
import { StudentAssignmentsResolver } from "./student-assignments.resolver"
import { StudentClassesResolver } from "./student-classes.resolver"
import { AuthRequiredGuard } from "../guards/AuthRequired.guard"
import { StudentHeroImagesResolver } from "./student-hero-images.resolver"

const studentRoutes: Routes = [
    {
        path: "",
        component: StudentHomepageComponent,
        resolve: { heroImages: StudentHeroImagesResolver },
    },
    {
        path: "assignments",
        component: StudentAssignmentsComponent,
        // We need to reload data on same page navigation
        runGuardsAndResolvers: "always",
        resolve: { assignments: StudentAssignmentsResolver },
        canActivate: [AuthRequiredGuard],
    },
    // Projects is no longer an available feature
    { path: "projects", redirectTo: "" },
    {
        path: "classes",
        component: StudentClassesComponent,
        // We need to reload data on same page navigation
        runGuardsAndResolvers: "always",
        resolve: { classes: StudentClassesResolver },
        canActivate: [AuthRequiredGuard],
    },
    {
        path: "join/:rosterCode",
        component: StudentClassesComponent,
        resolve: { classes: StudentClassesResolver },
        canActivate: [AuthRequiredGuard],
    },
    { path: "code/:code", component: StudentAssignmentComponent },
    {
        path: "**",
        loadChildren: () => import("../embed/embed.module").then((m) => m.EmbedModule),
    },
]

@NgModule({
    imports: [RouterModule.forChild(studentRoutes)],
    exports: [RouterModule],
})
export class StudentRoutingModule {}
